export const ASSET_DIR = '/assets/images/business-model'

export const STRINGS = {
  PAGE_TITLE: 'Agricultural Services for Farmers | DeHaat Network',
  PAGE_DESCRIPTION:
    'A one-stop shop for all the agricultural services by DeHaat Centres, Nodes, Input Vendor, Institutional Buyer. Micro-finance and Agri Insurance services are available to the farmers as well.',
  DEHAAT_NETWORK: 'DeHaat Network',
  FARMERS: 'Registered Farmers',
  DEHAAT_CENTERS: 'DeHaat Centers',
  NODES: 'Nodes',
  INPUT_SUPPLIERS: 'Input Suppliers',
  CORPORATE_BUYERS: 'Corporate Buyers',
  DEHAAT_CENTER: 'DeHaat Centre',
  DEHAAT_CENTER_DESCRIPTION:
    'DeHaat Centre is a one-stop-shop for full-stack agricultural services. Farmer gets access to quality material inputs, coordinates the sale of their produce to institutional buyers and receives science-based farming advisory in a timely manner, often personalized based on their specific farming conditions. Micro-finance and Agri Insurance services will soon be available to the farmers as well. Chain of DeHaat Centres are dotting the countryside in our operation zone - most of them operated by the local franchise owners, also known as DeHaat Micro-Entrepreneur or DeHaat Coordinator. They are the reliable and friendly “human interface” on the ground who build trust with farmers and are an essential part of Last Mile Access that makes true differences in the overall value chain of our operations.',
  NODE: 'Node',
  NODE_DESCRIPTION:
    'The collection of DeHaat Centres are connected to a Node, organized in a hub-and-spoke operational model. The Node provides a full range of services to its constituent franchise owners including sales incentives, stock delivery, inventory management, onboarding, training, and business development.',
  INPUT_VENDOR: 'Input Vendor',
  INPUT_VENDOR_DESCRIPTION:
    'DeHaat has built very strong supply-chain relationships with leading input manufactures and aggregators in our area of operations - linking them to our overall value chain. Our vendors and suppliers benefit from our data analytics and feedback on product and market performance, as part of our recent Digital Marketplace (Portal) initiative.',
  INSTITUTIONAL_BUYER: 'Institutional Buyer',
  INSTITUTIONAL_BUYER_DESCRIPTION:
    'We have a strong supply-chain operation for agri produce movement and we provide the best value for the farmer and the institutional buyers in our network. We have long-standing relationships with leading chain retailers and food producers in the country. The institutional buyers get benefit from our data analytics and forecasting technologies, as part of our recent Digital Marketplace (Portal) initiative.',
  READ_MORE: 'Read More',
}

const COUNTS = {
  FARMERS: 5000000,
  DEHAAT_CENTERS: 9500,
  NODES: 115,
  INPUT_SUPPLIERS: 70,
  CORPORATE_BUYERS: 250,
}

const LINKS = {
  INPUT_VENDOR: '/agri-input',
  INSTITUTIONAL_BUYER: '/agri-output-Harvest-and-Market-Access',
}

export const metricsList = [
  {
    heading: STRINGS.FARMERS,
    value: COUNTS.FARMERS,
  },
  {
    heading: STRINGS.DEHAAT_CENTERS,
    value: COUNTS.DEHAAT_CENTERS,
  },
  {
    heading: STRINGS.NODES,
    value: COUNTS.NODES,
  },
  {
    heading: STRINGS.INPUT_SUPPLIERS,
    value: COUNTS.INPUT_SUPPLIERS,
  },
  {
    heading: STRINGS.CORPORATE_BUYERS,
    value: COUNTS.CORPORATE_BUYERS,
  },
]

export const TABS = [
  {
    heading: STRINGS.DEHAAT_CENTER,
    description: STRINGS.DEHAAT_CENTER_DESCRIPTION,
    imageList: [
      {
        image: `${ASSET_DIR}/dehaat-center-1`,
        alt: 'Papu Bhij Bhandar',
      },
      {
        image: `${ASSET_DIR}/dehaat-center-2`,
        alt: 'DeHaat center in Varanasi',
      },
      {
        image: `${ASSET_DIR}/dehaat-center-3`,
        alt: 'Ankit Khad Bhandar, Tilhara',
      },
      {
        image: `${ASSET_DIR}/dehaat-center-4`,
        alt: 'Haji Khad Bhij Bhandar',
      },
    ],
    key: 'dehaat_center',
  },
  {
    heading: STRINGS.NODE,
    description: STRINGS.NODE_DESCRIPTION,
    imageList: [
      {
        image: `${ASSET_DIR}/node-1`,
        alt: 'DeHaat Nodal office, Devariya',
      },
      {
        image: `${ASSET_DIR}/node-2`,
        alt: 'DeHaat Nodal office, Mothihari',
      },
      {
        image: `${ASSET_DIR}/node-3`,
        alt: 'DeHaat Nodal office',
      },
      {
        image: `${ASSET_DIR}/node-4`,
        alt: 'DeHaat Nodal office, Devariya',
      },
    ],
    key: 'node',
  },
  {
    heading: STRINGS.INPUT_VENDOR,
    description: STRINGS.INPUT_VENDOR_DESCRIPTION,
    link: LINKS.INPUT_VENDOR,
    key: 'input_vendor',
  },
  {
    heading: STRINGS.INSTITUTIONAL_BUYER,
    description: STRINGS.INSTITUTIONAL_BUYER_DESCRIPTION,
    link: LINKS.INSTITUTIONAL_BUYER,
    key: 'institutional_buyer',
  },
]
